/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { useCallback } from 'react';

import isFunction from 'lodash/isFunction';
import { useDispatch } from 'react-redux';

import { modalOpen, modalSetStatusAction } from '@/main/modules/modal/modalActions';
import { EModalStatus } from '@/main/modules/modal/types/modalTypes';
import { IApiError } from '@/main/types/globalTypes';

import { ECreateNewsTypes } from '../../../constants';
import { IActionModalParams } from '../../../types';
import { NewsActionModal } from '../NewsActionModal';

export const useOpenPublishModal = () => {
    const dispatch = useDispatch();

    return useCallback(
        (
            type: ECreateNewsTypes,
            status: EModalStatus,
            options?: {
                params?: IActionModalParams;
                apiError?: IApiError;
            },
            handleCreate?: () => void,
            setSubmitting?: (isSubmitting: boolean) => void,
        ) => {
            dispatch(
                modalOpen({
                    modalParams: {
                        isCustomCrossButton: true,
                    },
                    onBackgroundCloseCallback: () => {
                        if (isFunction(setSubmitting)) setSubmitting(false);
                    },
                    render: ({ onCloseModal }) => {
                        return (
                            <NewsActionModal
                                apiError={options?.apiError}
                                handleCreate={handleCreate}
                                params={options?.params}
                                type={type}
                                onCloseModal={() => {
                                    if (isFunction(setSubmitting)) setSubmitting(false);
                                    onCloseModal();
                                }}
                            />
                        );
                    },
                }),
            );
            dispatch(modalSetStatusAction({ status }));
        },
        [dispatch],
    );
};
